import Vue from 'vue';

// 功能权限控制
export const getuserauth = () => Vue.axios.get('/user/basic/getuserauth').then(res => res.data);

// 用户、配送中心信息
export const getbasicdata = () => Vue.axios.get('/management/tpl/dynamictpl?type=3&display=json').then(res => res.data);

// 店铺共享下拉框列表
export const getaoishoplist = params => Vue.axios.get('/traveller/shop/getaoishoplist', { params }).then(res => res.data);

// 骑手名搜索
export const searchrider = params => Vue.axios.get('/traveller/rider/search', { params }).then(res => res.data);
// 订单搜索
export const searchorder = params => Vue.axios.get('/traveller/order/getorderlist', { params }).then(res => res.data);

// 店铺详细信息
export const getshopinfo = params => Vue.axios.get('/traveller/shop/getshopinfo', { params }).then(res => res.data);

// 获取品牌列表
export const getBrandList = params => Vue.axios.get('/traveller/order/getbrandlist', { params }).then(res => res.data);



// WEBPACK FOOTER //
// ./src/api/index.js